import React, { useCallback, useEffect, useState } from 'react';
import { Picker } from 'antd-mobile';
import styles from '../index.less';

const GroupSelect = ({
  showGroupList,
  setShowGroupList,
  currentGroup,
  chooseGroupOnChange,
  groupList,
}) => {
  const [groupsList, setGroupsList] = useState();

  const handlePickerChange = useCallback(
    val => {
      const chooseGid = val[0];
      // 如果这次的选择和上次的相同，就不再发送请求
      if (currentGroup.gid === chooseGid) {
        setShowGroupList(false);
        return;
      }
      const chooseGroup = groupList.find(item => item.gid === chooseGid);
      chooseGroupOnChange(chooseGroup);
    },
    [chooseGroupOnChange, currentGroup.gid, groupList, setShowGroupList]
  );

  useEffect(() => {
    let newGroupList = [];
    groupList &&
      groupList.forEach(element => {
        const item = {
          label: element.gname,
          value: element.gid,
        };
        newGroupList.push(item);
      });
    setGroupsList(newGroupList);
  }, [groupList]);

  return (
    <div>
      <div className={styles['pdd-filter']}>
        <Picker
          visible={showGroupList}
          data={groupsList}
          cols={1}
          value={[currentGroup.gid]}
          title="选择分组"
          onChange={handlePickerChange}
          onDismiss={() => {
            setShowGroupList(false);
          }}
        >
          {/* <p>{currentGroup.gname}</p> */}
        </Picker>
      </div>
    </div>
  );
};
export default GroupSelect;
